import { Spinner } from '../Loader';
import styles from './styles.module.scss';

const ButtonInput = (props) => {
  const { isLoading = false } = props;
  return (
    <>
      <div className={styles['btn-input-wrapper']}>
        <input className={styles['btn-input']} onChange={props.onChange} placeholder="Add Coupon Code" />

        <button type="button" className={styles['input-btn']} onClick={props.checkCode}>
          {isLoading ? <Spinner color={'white'} size={13} /> : 'Apply'}
        </button>
      </div>
    </>
  );
};

export default ButtonInput;
